import React from "react";
import { Check, Sparkles } from "lucide-react";

const items = [
  "Mais de 700 artes prontas",
  "Tags Premium",
  "Sacolas Personalizadas",
  "Caixas Prontas",
  "Adesivos Exclusivos",
  "Kits Temáticos",
  "Kits Escolares",
  "Etiquetas e Lacres",
  "Cartões de Agradecimento",
];

const WhatYouGet = () => {
  return (
    <section className="section-pad bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-[11px] md:text-xs font-bold tracking-widest text-pink-600 uppercase">
            <Sparkles className="w-4 h-4" /> Acesso Imediato
          </span>
          <h2 className="mt-2 font-serif-display font-black text-2xl md:text-5xl text-pink-700 leading-tight">
            Tudo que você vai receber
          </h2>
          <p className="mt-2 md:mt-3 text-pink-900/70 text-sm md:text-base">Direto no seu WhatsApp e e-mail em poucos minutos.</p>
        </div>

        <div className="mt-6 md:mt-10 mx-auto max-w-3xl bg-gradient-to-br from-pink-50 to-rose-50 border-2 border-pink-200 rounded-3xl p-5 md:p-10 shadow-lg">
          <ul className="grid sm:grid-cols-2 gap-2.5 md:gap-3">
            {items.map((t, i) => (
              <li key={i} className="flex items-center gap-3 text-pink-900 font-medium text-sm md:text-base">
                <span className="w-5 h-5 md:w-6 md:h-6 shrink-0 rounded-full bg-pink-500 text-white grid place-content-center">
                  <Check className="w-3 h-3 md:w-4 md:h-4" strokeWidth={3} />
                </span>
                {t}
              </li>
            ))}
          </ul>

          <div className="mt-6 md:mt-8 pt-4 md:pt-6 border-t border-pink-200 text-center">
            <p className="text-pink-900/80 text-sm md:text-base">
              E não para por aí... <strong className="text-pink-700">Tem MUITO mais!</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouGet;
